import { useMutation, useQuery } from "@tanstack/react-query";
import { getApplicationPhase, saveApplication as saveApplicationApi } from "../../api/application";
import { ApplicationDto, ApplicationImageDto } from "../../types/applicationTypes";
import { showErrorMessage } from "../../utils/toastUtils";

/**
 * Hook that handles the application api calls, uses react-query
 * @returns applicationPhase, isApplicationPhaseLoading, saveApplication
 */
const useApplicationProcess = () => {
  // getApplicationPhase query
  const { data: applicationPhaseData, isLoading: isApplicationPhaseLoading } = useQuery({
    queryKey: ["applicationPhase"],
    queryFn: getApplicationPhase,
  });

  const applicationPhase = applicationPhaseData ? applicationPhaseData.data : null;

  const saveApplicationMutation = useMutation({
    mutationFn: ({
      application,
      applicationImage,
    }: {
      application: ApplicationDto;
      applicationImage: ApplicationImageDto;
    }) => saveApplicationApi(application, applicationImage),
    onError: () => {
      showErrorMessage("Bewerbung wurde nicht gespeichert!");
    },
  });

  /**
   * Function to save the application
   * @param application The application to save
   * @param applicationImage The application image to save
   * @returns The saved application
   */
  const saveApplication = async (application: ApplicationDto, applicationImage: ApplicationImageDto) => {
    return await saveApplicationMutation.mutateAsync({ application, applicationImage });
  };

  return {
    applicationPhase,
    isApplicationPhaseLoading,
    saveApplication,
  };
};

export default useApplicationProcess;
